var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"js-apilist-filter",attrs:{"value":_vm.query,"label":"Search API","hide-details":""},on:{"input":function (q) { return _vm.$store.dispatch('setQuery', q); }}})}
var staticRenderFns = []

export { render, staticRenderFns }